import { KeesingGames } from '@/components/KeesingGames';
import { LabradorComponent } from '@/types/component';

export const LabradorKeesingGames: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <KeesingGames {...props} />;
};
